import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (item: BonusAmountCellContent.Props["item"]) => {
	if (!isNumber(item?.ordersCounters?.bonus?.amount)) {
		return formatNumber(0);
	}
	return formatNumber(item?.ordersCounters?.bonus?.amount);
};

const BonusAmountCellContent: React.FC<BonusAmountCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace BonusAmountCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default BonusAmountCellContent;
